import triggerTracking from '@blueprint/tracking/dist/Tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

export const trackSavedListingClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'clickthrough',
        eventLabel: 'saved property'
    });
};

export const trackOpenMenuModal = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'open saved property menu modal'
    });
};

export const trackCloseMenuModal = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'close saved property menu modal'
    });
};

export const trackOpenShareModal = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'open saved property share modal'
    });
};

export const trackCloseShareModal = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'close saved property share modal'
    });
};

export const trackContactAgentClick = (listingId: string) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'saved property contact agent',
        eventValue: parseInt(listingId, 10)
    });
};
